(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-v2"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');

      /* section index 1 */
      this.triggerSection = document.querySelector(
        '[data-section-id="1"]'
      );

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.setHeaderHeight();

      window
        .matchMedia('(max-width: 990px)')
        .addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {

      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      /* section 1 completely gone */
      const triggerPoint =
        this.triggerSection.offsetTop +
        this.triggerSection.offsetHeight;

      if (scrollTop >= triggerPoint) {

        this.header.classList.add(
          'scrolled-past-header',
          'shopify-section-header-sticky'
        );

      } else {

        this.header.classList.remove(
          'scrolled-past-header',
          'shopify-section-header-sticky'
        );
      }

      this.currentScrollTop = scrollTop;
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-v4"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');

      /* section index 1 */
      this.triggerSection = document.querySelector('[data-section-id="1"]');

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      /* section 1 completely gone */
      const triggerPoint = this.triggerSection.offsetTop + this.triggerSection.offsetHeight;

      if (scrollTop >= triggerPoint) {
        this.header.classList.add('scrolled-past-header', 'shopify-section-header-sticky');
      } else {
        this.header.classList.remove('scrolled-past-header', 'shopify-section-header-sticky');
      }

      this.currentScrollTop = scrollTop;
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');

    if (window.matchMedia('(max-width: 749px)').matches) {
      this.classList.add('is-mobile');
    } else {
      this.classList.add('is-desktop');
    }

    /* section index 1 */
    this.triggerSection = document.querySelector('[data-section-id="1"]');

    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';

    this.setHeaderHeight();

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    /* jitter fix: hysteresis + rAF throttle taaki boundary ke
       aas-paas class baar-baar toggle na ho */
    this.isPastTrigger = false;
    this.buffer = 10; // px hysteresis
    this.ticking = false;

    this.onScrollHandler = this.onScroll.bind(this);

    window.addEventListener('scroll', this.onScrollHandler, { passive: true });
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;

    requestAnimationFrame(() => {
      this.handleScroll();
      this.ticking = false;
    });
  }

  handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    if (!this.triggerSection || !this.header) return;

    /* section 1 completely gone */
    const triggerPoint = this.triggerSection.offsetTop + this.triggerSection.offsetHeight;
    const megaLogo = document.querySelector('.logo_is_megamenu');

    if (!this.isPastTrigger && scrollTop >= triggerPoint + this.buffer) {
      this.isPastTrigger = true;
    } else if (this.isPastTrigger && scrollTop < triggerPoint - this.buffer) {
      this.isPastTrigger = false;
    }

    window.headerPastTrigger = this.isPastTrigger;

    const hasClass = this.header.classList.contains('scrolled-past-header');

    if (this.isPastTrigger && !hasClass) {
      this.header.classList.add('scrolled-past-header', 'shopify-section-header-sticky');
      if (megaLogo) megaLogo.style.display = 'none';
    } else if (!this.isPastTrigger && hasClass) {
      this.header.classList.remove('scrolled-past-header', 'shopify-section-header-sticky');
      if (megaLogo) megaLogo.style.display = 'none';
    }

    this.currentScrollTop = scrollTop;
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
